import { useSelector } from 'react-redux'
import { RootState } from 'store/redux'

export default function useIsTrancparency() {
    const store = useSelector((state: RootState) => state.MoneyPoolBoxAdd)
    const isTranspancy = () => {
        return (
            store?.showDebt !== undefined ||
            store.showOtherRecieverLoans !== undefined ||
            store?.showOtherTransaction !== undefined ||
            store?.showOtherWantedLoan !== undefined ||
            store.showOthersData !== undefined ||
            store?.showOverdue !== undefined
        )
    }
    const isAnnouncement = () => {
        return (
            store?.sendMessageDepositToManager !== undefined ||
            store?.sendMessageLoanToOthers !== undefined ||
            store?.sendMessageRememberLoan !== undefined ||
            store?.sendMessageRememberMemberShip !== undefined ||
            store?.sendPushNotificationToAllMembers !== undefined ||
            store?.sendPushNotificationToOthers !== undefined
        )
    }
    const handlePayload = () => {
        const payload: IAddBoxFirstPayload = {
            name: store?.name,
            ...(store?.image_id !== undefined && { image_id: store?.image_id }),
            share_value: Number(store?.memberShipFee),
            day_of_duetion: Number(store?.date),
            interval: store?.dueDate === 'weekly' ? 'wkl' : 'mnt',
            made_by_kuching: store.help ? store.help : false,
            box_setting: {
                ...(isTranspancy() && {
                    transparency_setting: {
                        ...(store?.showOtherRecieverLoans !== undefined && {
                            show_others_loans: store?.showOtherRecieverLoans,
                        }),
                        ...(store.showOtherWantedLoan !== undefined && {
                            show_others_loan_demands: store.showOtherWantedLoan,
                        }),
                        ...(store.showOtherTransaction !== undefined && {
                            show_others_transactions:
                                store.showOtherTransaction,
                        }),
                        ...(store.showOverdue !== undefined && {
                            show_other_members: store.showOverdue,
                        }),
                        ...(store.showOthersData !== undefined && {
                            show_others_to_be_paid_portion:
                                store.showOthersData,
                        }),
                        ...(store.showBalance !== undefined && {
                            show_box_balance: store.showBalance,
                        }),
                        ...(store.showDebt !== undefined && {
                            show_others_installments: store.showDebt,
                        }),
                        id: 0,
                    },
                }),
                ...(isAnnouncement() && {
                    announcement_setting: {
                        ...(store?.sendMessageLoanToOthers !== undefined && {
                            sms_others_define_loan:
                                store?.sendMessageLoanToOthers,
                        }),
                        ...(store?.sendMessageRememberMemberShip !==
                            undefined && {
                            sms_pay_portion_reminder:
                                store?.sendMessageRememberMemberShip,
                        }),
                        ...(store?.sendMessageRememberLoan !== undefined && {
                            sms_pay_installment_reminder:
                                store?.sendMessageRememberLoan,
                        }),
                        ...(store?.sendMessageDepositToManager !==
                            undefined && {
                            sms_inform_managers_of_cashins:
                                store?.sendMessageDepositToManager,
                        }),
                        ...(store?.sendPushNotificationToOthers !==
                            undefined && {
                            message_others_loan:
                                store?.sendPushNotificationToOthers,
                        }),
                        ...(store?.sendPushNotificationToAllMembers !==
                            undefined && {
                            notif_others_loan:
                                store?.sendPushNotificationToAllMembers,
                        }),
                        sms_opening_time: '00:00',
                        sms_closing_time: '23:59',
                        id: 0,
                    },
                }),
            },
        }
        return payload
    }
    return { handlePayload }
}
